import { queryOptions } from '@tanstack/react-query';
import { Domain } from '@repo/domain';
import { resolveRepository } from '../registry/resolveRepository';
export const consentKeys = {
    all: ['consents'],
    get: (filter) => ['consents', filter],
};
export const consentOptions = {
    get: (filter) => queryOptions({
        queryKey: consentKeys.get(filter),
        queryFn: async () => {
            const repo = await resolveRepository(Domain.Consent);
            return repo.get(filter);
        },
    }),
    accept: () => ({
        mutationFn: async (request) => {
            const repo = await resolveRepository(Domain.Consent);
            return repo.accept(request);
        },
    }),
};
